// extracted by mini-css-extract-plugin
export var attachButton = "_cb-8";
export var sendButton = "_cb-2";
export var sendDisabled = "_cb-4";
export var sendEnabled = "_cb-3";
export var sendIcon = "_cb-6";
export var sendIconDisabled = "_cb-7";
export var sendStreaming = "_cb-5";
export var textarea = "_cb-1";
export var wrapper = "_cb-0";